import React from "react";
import { ReactComponent as OfficeBag } from "../../assets/svg/office_bag.svg";
import { ReactComponent as CheckCircle } from "../../assets/svg/check-circle.svg";
import { ReactComponent as QuestionMark } from "../../assets/svg/question_mark.svg";
import { ReactComponent as Mail } from "../../assets/svg/mail.svg";
import { ReactComponent as TumbsUp } from "../../assets/svg/thumbs-up.svg";
import { Button } from "../Shared/Buttons/Button";
import { useMediaQuery } from "react-responsive";
import { SummaryOfCompletionModel } from "../../models/SummaryOfCompletionModel";

interface Props {  
    styles: any;
    model: SummaryOfCompletionModel;
    onPreview: () => void;
    onSubmit: () => void;
    editStage?: boolean;
    isSubmitting?: boolean;
}

export const SummaryOfCompletion: React.FC<Props> = (props) => {
    const isMobile = useMediaQuery({ query: "(max-width: 786px)" });
    const styles = props.styles;   
    const model = props.model;
    const editStage = props.editStage;
    const isSubmitting = !!props.isSubmitting;
    const finalStage =  props.model.submission;
    const textWhite = (finalStage || editStage) ? styles.textWhite : {};
    const svgWhite = (finalStage && !editStage) ? styles.svgWhite : {};

    return( 
        <>{isMobile ? 
            <div 
                style={{
                    ...styles.fullWrapper, 
                    ...(finalStage && styles.backgroundBlue),
                    ...(editStage && styles.backgroundBlack)
                }}
            >
                <div style={{...styles.tittle, ...textWhite}}>{"Summary of Completion"}</div>
                <div style={styles.mainWrapper}>
                    <div style={styles.infoWrapper}>
                        <div 
                            style={{
                                ...styles.logoWrapper, 
                                ...styles.logoWrapper.present, 
                                ...(model.basicInfo && styles.logoWrapper.complete),
                                ...(editStage && styles.logoWrapper.present)
                            }}
                        >
                            <OfficeBag style={styles.logoBag}/>
                        </div>
                        <div 
                            style={{
                                ...styles.logoBag.semiLine, 
                                ...(model.basicInfo && styles.logoBag.semiLine.complete),
                                ...(editStage && styles.logoBag.semiLine.editStage)
                            }}
                        >
                        </div>
                    </div>
                    <div style={styles.infoWrapper}> 
                        <div 
                            style={{
                                ...styles.logoWrapper, 
                                ...((model.vacancyQuestions || model.cvLessQuestion) && styles.logoWrapper.present), 
                                ...(model.replyMail && styles.logoWrapper.complete),
                                ...(editStage && styles.logoWrapper.present)
                            }}
                        >
                            <QuestionMark style={styles.logoQuestionMark}/>
                        </div>
                        <div 
                            style={{
                                ...styles.logoQuestionMark.semiLine, 
                                ...((model.vacancyQuestions || editStage) && styles.logoQuestionMark.semiLine.complete),
                                ...(editStage && styles.logoQuestionMark.semiLine.editStage)
                            }}
                        ></div>
                    </div>
                    <div style={styles.infoWrapper}>
                        <div 
                            style={{
                                ...styles.logoWrapper, 
                                ...(model.replyMail && styles.logoWrapper.present), 
                                ...(model.submission && styles.logoWrapper.complete),
                                ...(editStage && styles.logoWrapper.present)
                            }}
                        >
                            <Mail style={styles.logoMail}/>
                        </div>
                        <div 
                            style={{
                                ...styles.logoMail.semiLine,
                                ...(model.submission && styles.logoMail.semiLine.complete),
                                ...(editStage && styles.logoMail.semiLine.editStage)
                            }}
                        ></div>
                    </div>
                    <div style={styles.infoWrapper}>
                        <div 
                            style={{
                                ...styles.logoWrapper,
                                ...(model.submission && styles.logoWrapper.finalStage),
                                ...(editStage && styles.logoWrapper.present)
                            }}
                        >
                            <TumbsUp style={{...styles.logoTumbUp, ...(finalStage && styles.logoTumbUp.finalStage), ...(editStage && styles.logoTumbUp)}}/>
                        </div>
                    </div>
                </div>
                {model.submission && <Button style={styles.submitButton} onClick={props.onSubmit}>{"SUBMIT"}</Button>}
            </div>
            : <div style={styles.fullWrapper}>
                <div style={styles.tittle}>{"Summary of Completion"}</div>
                <div 
                    style={{
                        ...(finalStage && styles.submitionWrapper), 
                        ...editStage && styles.submitionWrapper.editStage
                    }}
                >
                    <div 
                        style={{
                            ...styles.mainWrapper, 
                            ...(finalStage && styles.backgroundBlue), 
                            ...(editStage && styles.backgroundBlack)
                        }}
                    >
                        <div style={styles.infoWrapper}>
                            <div style={styles.infoLeftWrapper}>
                                <div style={{...styles.logoWrapperBag, ...((!editStage && model.basicInfo) && styles.logoWrapperBag.complete)}}>
                                    <OfficeBag style={styles.logoBag}/>
                                </div>
                                <div 
                                    style={{
                                        ...styles.logoBag.semiLine, 
                                        ...(model.basicInfo && styles.logoBag.semiLine.complete), 
                                        ...(editStage && styles.logoBag.semiLine.editStage)
                                    }}
                                ></div>
                            </div>
                            <div style={styles.infoRightWrapper}>
                                <div style={{...styles.topic, ...textWhite}}>{"Basic Info"}</div>
                                <div style={{...styles.subTopic, ...textWhite}}>{"Required"}{model.required  && <CheckCircle style={{...styles.checkCircle, ...svgWhite}}/>}</div>
                                <div style={{...styles.subTopic, ...textWhite}}>{"Salary"}{model.salary && <CheckCircle style={{...styles.checkCircle, ...svgWhite}}/>}</div>
                                <div style={{...styles.subTopic, ...textWhite}}>{"Description"}{model.description &&<CheckCircle style={{...styles.checkCircle, ...svgWhite}}/>}</div>
                            </div>
                        </div>
                        <div style={styles.infoWrapper}>
                            <div style={styles.infoLeftWrapper}>
                                <div 
                                    style={{
                                        ...styles.logoWrapper, 
                                        ...((model.vacancyQuestions || model.cvLessQuestion) && styles.logoWrapper.current), 
                                        ...(model.replyMail && styles.logoWrapper.complete),
                                        ...(editStage && styles.logoWrapper.current)
                                    }}
                                >
                                    <QuestionMark style={styles.logoQuestionMark}/>
                                </div>
                                <div 
                                    style={{
                                        ...styles.logoQuestionMark.semiLine, 
                                        ...(model.replyMail && styles.logoQuestionMark.semiLine.complete), 
                                        ...(editStage && styles.logoQuestionMark.semiLine.editStage)
                                    }}
                                ></div>
                            </div>
                            {model.cvLessQuestion ? <div style={styles.infoRightWrapper}>
                                <div style={{...styles.topic, ...textWhite}}>{"CV Less"}</div>
                                <div style={{...styles.subTopic, ...textWhite}}>{"Service"}{model.service && <CheckCircle style={{...styles.checkCircle, ...svgWhite}}/>}</div>
                                <div style={{...styles.subTopic, ...textWhite}}>{"Question"}{model.question && <CheckCircle style={{...styles.checkCircle, ...svgWhite}}/>}</div>
                            </div> 
                            : <div style={styles.infoRightWrapper}>
                                <div style={{...styles.topic, ...textWhite}}>{"Vacancy Questions"}</div>
                                <div style={{...styles.subTopic, ...textWhite}}>{"Pass Score"}{model.passScore && <CheckCircle style={{...styles.checkCircle, ...svgWhite}}/>}</div>
                            </div>}
                        </div>
                        <div style={styles.infoWrapper}>
                            <div style={styles.infoLeftWrapper}>
                                <div 
                                    style={{
                                        ...styles.logoWrapper, 
                                        ...(model.replyMail && styles.logoWrapper.current), 
                                        ...(model.submission && styles.logoWrapper.complete),
                                        ...(editStage && styles.logoWrapper.current) 
                                    }}
                                >
                                    <Mail style={styles.logoMail}/>
                                </div>
                                <div 
                                    style={{
                                        ...styles.logoMail.semiLine, 
                                        ...(model.submission && styles.logoMail.semiLine.complete), 
                                        ...(editStage && styles.logoMail.semiLine.editStage)
                                    }}
                                ></div>
                            </div>
                            <div style={styles.infoRightWrapper}>
                                <div style={{...styles.topic, ...textWhite}}>{"Reply Mail"}</div>
                                <div style={{...styles.subTopic, ...textWhite}}>
                                    {"Optional"}
                                    {model.optional && <CheckCircle style={{...styles.checkCircle, ...svgWhite}}/>}
                                </div>
                            </div>
                        </div>
                        <div style={styles.infoWrapper}>
                            <div style={styles.infoLeftWrapper}>
                                <div 
                                    style={{
                                        ...styles.logoWrapper,
                                        ...(model.submission && styles.logoWrapper.finalStage),
                                        ...(editStage && styles.logoWrapper.current)
                                    }}
                                >
                                <TumbsUp style={{...styles.logoTumbUp, ...(finalStage && styles.logoTumbUp.finalStage), ...(editStage && styles.logoTumbUp)}}/></div>
                            </div>
                            <div style={styles.infoRightWrapper}>
                                <div style={{...styles.topic, ...textWhite}}>{"Submission"}</div>
                                <div style={{...styles.subTopic, ...textWhite}}>
                                    {"Submit"}
                                    {model.submission && <CheckCircle style={{...styles.checkCircle, ...svgWhite}}/>}
                                </div>
                            </div>
                        </div>
                    </div>
                    {!editStage && model.submission && <Button style={styles.viewButton} onClick={props.onPreview}>{"VIEW HOW ITS LOOKS"}</Button>}
                    <Button style={styles.submitButton} onClick={props.onSubmit} disabled={isSubmitting}>{"SUBMIT"}</Button>
                </div>
            </div> 
        }
        </>            
    )
}